import template from './synonym-source-form.html.twig';

const { Component, Mixin } = Shopware;

Component.register('topdata-es-synonym-source-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.modalTitleAdd')
                : this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.modalTitleEdit');
        },

        scopeOptions() {
            return [{
                value: 'GLOBAL',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.scopeGlobal'),
            }, {
                value: 'PRODUCT',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.scopeProduct'),
            }, {
                value: 'CATEGORY',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.scopeCategory'),
            }];
        },
    },

    methods: {
        onSave() {
            if (!this.entity.name || !this.entity.name.trim() || !this.entity.url || !this.entity.url.trim()) return;

            ['language', 'columnScope', 'columnLanguage'].forEach((key) => {
                if (this.entity[key] === '') {
                    this.entity[key] = null;
                }
            });

            this.isLoading = true;
            this.repository.save(this.entity).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.saveSuccess'),
                });
                this.$emit('save', this.entity);
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});
